import { Injectable } from "@angular/core";
import { MessagingAPIService } from "../messaging-api.service";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map, of, switchMap } from "rxjs";
import {
    deleteChannel,
    emptyEvent,
    insertWebSocketEventData,
    setActiveChannel,
    upsertActiveChannelAndMessage,
    upsertChannels
} from "./messaging.actions";
import { withLatestFrom } from "rxjs/operators";
import { Store } from "@ngrx/store";
import { selectChannelIdToChannelMap, selectTopicValidationKeyMap } from "./messaging.selector";
import { Channel } from "../../../core/models/messaging.models";

@Injectable()
export class MessagingEffects {

    constructor(
        private actions$: Actions,
        private _store: Store,
        private _messagingAPIService: MessagingAPIService
    ) {
    }

    setActiveChannelEffect = createEffect(() => this.actions$.pipe(
        ofType(setActiveChannel),
        withLatestFrom(this._store.select(selectChannelIdToChannelMap)),
        switchMap(([data, channelIdToChannelMap]) => {
            if (data.channelId in channelIdToChannelMap) {
                return of(upsertChannels({
                    channels: []
                }));
            } else {
                return this._messagingAPIService.fetchChannelById(data.channelId).pipe(
                    map((channel: Channel) => {
                        if (channel) {
                            return upsertChannels({
                                channels: [channel]
                            });
                        } else {
                            return upsertChannels({
                                channels: []
                            });
                        }
                    })
                );
            }
        })
    ));

    insertWebSocketEventDataEffect = createEffect(() => this.actions$.pipe(
        ofType(insertWebSocketEventData),
        withLatestFrom(this._store.select(selectTopicValidationKeyMap)),
        switchMap(([event, topicValidationKeyMap]) => {
                if (topicValidationKeyMap[event.topic] === event.key) {
                    let eventType = event.eventData.event_type;
                    switch (eventType) {
                        case 'MessageUpsertV2':
                            return of(upsertActiveChannelAndMessage({
                                message: event.eventData.message,
                                channel: event.eventData.channel,
                            }));
                        case 'ChannelUpsertV2':
                        case 'ChannelUpdateV2':
                            return of(upsertChannels({
                                channels: [
                                    event.eventData.channel,
                                ],
                            }))
                        case 'ChannelDeleteV2':
                            return of(deleteChannel({
                                channelId: event.eventData.channel_id
                            }));
                    }
                } else {
                    console.error('Skipping event due to key mismatch', topicValidationKeyMap[event.topic], event);
                }
                return of(emptyEvent());
            }
        )
    ))
}
